// extracted by mini-css-extract-plugin
export default {"black":"Button_black__cAdZ+","white":"Button_white__bAHSJ","variant1":"Button_variant1__pfcNt","variant2":"Button_variant2__fzlSc","button":"Button_button__wwPXe"};